<template>
    <div
        class="home"
        :style="{
            background:
                route.name === 'allCategories'
                    ? '#F4F8FE'
                    : '#fff',
        }"
    >
        <WindowScroll :class="route.name + '-i'" />
        <Breadcrumb
            v-if="route.name !== 'proHome' && route.name !== 'catalog' && route.name !== 'details' && route.name !== 'content' && route.name !== 'NotFound'&& route.name !== 'sitemap' "></Breadcrumb>
        <router-view
            v-slot="{ Component }"
            :style="{ minHeight: innerHeight + 'px', marginTop: route.name !== 'proHome' && route.name !== 'catalog' && route.name !== 'details' && route.name !== 'content' && route.name !== 'NotFound'&& route.name !== 'sitemap' ? '0' : '134px'}"
        >
            <component :is="Component" />
        </router-view>
        <Footer :class="route.name + '-i'" />
        <FlexSide />
    </div>
</template>
<script lang="ts">

import Breadcrumb from '@/components/ProShop/breadcrumb.vue'
import {
    reactive,
    toRefs,
    defineComponent,
    getCurrentInstance,
    onBeforeMount,
    computed,
} from 'vue';
import { useRoute,RouteRecordRaw } from 'vue-router';
import Header from '@/components/ProShop/Header.vue';
import Footer from '@/components/ProShop/Footer.vue';
import WindowScroll from '@/components/ProShop/WindowScroll.vue';
import { useUserStore } from '@/store/User';
import FlexSide from '@/components/ProShop/flexSide.vue';

export default defineComponent({
    name: 'ProIndex',
    components: {
        Header,
        Footer,
        WindowScroll,
        FlexSide,
        Breadcrumb,
    },
    setup() {
        const { proxy }: any = getCurrentInstance();
        let route = useRoute();
        const store = useUserStore();
        const data = reactive({
            innerHeight: 0,
        });
        const refData = toRefs(data);
        onBeforeMount(() => {
            store.getMessage();
            refData.innerHeight.value = window.innerHeight -134 -350;
        });

        return {
            ...refData,
            route,
        };
    },
});
</script>
<style lang="scss">
.home {
    width: 100%;
    padding-top: 124px;
}
</style>
